import React from 'react'
import AdmSearchExpense from "../../components/AdminTabs/AdminSearchExpense/AdmSearchExpense"

const SearchExpense = () => {
  return (
    <div>
      <AdmSearchExpense/>
    </div>
  )
}

export default SearchExpense